export default {
  actions: {},
  getters: {},
  mutations: {
    setSideNavigation(state, showNavigation) {
      if (showNavigation === undefined) {
        state.showSideNavigation = !state.showSideNavigation;
        return;
      }
      state.showSideNavigation = showNavigation;
    },
  },
  namespaced: true,
  state: {
    showSideNavigation: true,
  },
};
